import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';
import config from '../config';

const ProjectsWrapper = styled.div`
  margin: 0 -15px;
  float: left;
  height: auto;
  width: 100%;
`;

const ProjectWrapper = styled.div`
  padding: 15px;
  width: 33%;
  float: left;
`;
const Project = styled.div`
  margin: 5px;
  padding: 10px 15px;
  border-radius: 3px;
  font-size: 20px;
  background: ${(props) => (props.active ? props.theme.primary1Color : '#efefef')};
  cursor: pointer;
  text-align: center;
`;

const ModalLauncher = styled.div`
  position: fixed;
  right: 0px;
  top: 0px;
  z-index: 1000;
  background: ${(props) => props.theme.primary1Color};
  width: 20px;
  height: 20px;
  text-align: center;
  cursor: pointer;
`;

export default class extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    const projectKey = config.getProjectKey();
    this.state = {
      projectKey,
      visible: projectKey !== null ? false : true,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const {loading, allProjects} = nextProps;

    if (this.props.loading && !loading) {
      if (allProjects.length === 1) {
        config.writeProjectKey(allProjects[0].key);
        this.setState({visible: false, projectKey: allProjects[0].key}, () => this.handleChangeProject);
      }
    }
  };

  _renderProjects = (allProjects, projectKey) => {
    if (allProjects && allProjects.length > 0) {
      return (
        <ProjectsWrapper>
          {allProjects.map((proj) => (
            <ProjectWrapper key={proj._id}>
              <Project data-key={proj.key} onClick={this.handleProjectClick} active={proj.key === projectKey}>
                {proj.name}
              </Project>
            </ProjectWrapper>
          ))}
        </ProjectsWrapper>
      );
    }
  };

  handleProjectClick = (event) => {
    const projectKey = event.target.dataset['key'];
    this.setState({projectKey});
  };

  handleChangeProject = () => {
    config.writeProjectKey(this.state.projectKey);
    this.setState({visible: false});
    window.location.reload();
  };
  handleLauncherClick = () => {
    this.setState({visible: true});
  };

  setProject = () => {};
  render() {
    const {
      data: {loading, allProjects},
    } = this.props;
    const {visible, projectKey} = this.state;
    return (
      <div>
        <ModalLauncher onClick={this.handleLauncherClick} />
        <Dialog
          modal
          title='Select Project'
          open={visible}
          style={{width: '90%'}}
          overlayStyle={{background: config.colors.primaryColor}}
          actions={[<FlatButton key={'ok'} label='Ja' onClick={this.handleChangeProject} primary />]}>
          {loading && <LoadingIndicator />}
          {this._renderProjects(allProjects, projectKey)}
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectSelectModal.js